import React, { useState } from 'react';
import {
  Button, TextField,
} from 'gatorcomponents';
import * as Styles from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import { homeAnalytics } from '@/analytics/home';

const DomainOffer = ({ locale, onSearchDomain }) => {
  const [domainSearchValue, setDomainSearchValue] = useState('');

  const handleSearchDomain = () => {
    homeAnalytics.freeDomainSearchClick();
    onSearchDomain(domainSearchValue);
  };

  return (
    <Styles.FreeDomainCard data-testid="home-free-domain-card">
      <Styles.FreeDomainTitle>
        {locale.titlePrefix}
        <strong>{locale.titleBold}</strong>
      </Styles.FreeDomainTitle>
      <Styles.FreeDomainDescription>
        {locale.description}
      </Styles.FreeDomainDescription>
      <Styles.FreeDomainSearchRow>
        <Styles.FreeDomainInputWrapper>
          <TextField
            testId="home-free-domain-search-input"
            label={locale.search.placeholder}
            value={domainSearchValue}
            onChange={e => setDomainSearchValue(e.target.value)}
            onKeyDown={({ key }) => key === 'Enter' && handleSearchDomain()}
            type="search"
            onClickIcon={handleSearchDomain}
            onClear={() => setDomainSearchValue('')}
          />
        </Styles.FreeDomainInputWrapper>
        <Styles.FreeDomainSearchButtonWrapper>
          <Button
            testId="home-free-domain-search-button"
            label={locale.search.cta}
            onClick={handleSearchDomain}
            version="v2"
            size="large"
          />
        </Styles.FreeDomainSearchButtonWrapper>
      </Styles.FreeDomainSearchRow>
      <Styles.FreeDomainLinksRow>
        {locale.links.prefix}
        {' '}
        <Styles.FreeDomainLink href={locale.links.transfer.link} target="_blank" rel="noopener noreferrer">
          {locale.links.transfer.label}
        </Styles.FreeDomainLink>
        {` ${locale.links.separator} `}
        <Styles.FreeDomainLink href={locale.links.configure.link} target="_blank" rel="noopener noreferrer">
          {locale.links.configure.label}
        </Styles.FreeDomainLink>
      </Styles.FreeDomainLinksRow>
    </Styles.FreeDomainCard>
  );
};

export default DomainOffer;
